import React from "react";
import SocialLinks from "./social";
import "./footer.css";
import instagramIcon from "../images/Instagram_Glyph_Gradient.png";

const SocialButtons = () => (
    <>
        <div className="footer-social" style={{
            width: "100%", padding: "5px", alignContent: "center", display: "flex", justifyContent: "center"
        }}> <text style={{ color: "red", fontWeight: "bold" }}>Videos &nbsp; : &nbsp;</text>
            <SocialLinks
                links={[
                    {
                        name: "Instagram",
                        url: "https://instagram.com/small_temples_",
                        icon: instagramIcon,
                    },
                ]}
            />
        </div>
    </>
);

export default SocialButtons;